import { useQuery } from '@tanstack/react-query';
import { authApi, TenantBranding } from '../api/auth';
import { deriveThemePalette, ThemePalette } from './deriveThemePalette';

/**
 * The live theme palette, for components that can't read CSS custom
 * properties (MapLibre's paint properties are evaluated in a WebGL shader —
 * see StateMap.tsx). Shares the `tenant_branding` query cache with
 * SiteHeader, so this costs no extra request.
 */
export function useThemePalette(): ThemePalette {
  const { data: branding } = useQuery<TenantBranding>({
    queryKey: ['tenant_branding'],
    queryFn: authApi.getBranding,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
  return deriveThemePalette(branding);
}
